import React, { useState, useEffect, useRef } from 'react'

import { CircularProgress } from '@material-ui/core'
import axios from 'axios'

import './index.scss'

const AnswerPanel = ({
    onSend,
    sendingProgress,
    conversation,
    selectedChannel,
}) => {
    const [message] = useState('')
    // const [signature, setSignature] = useState('')
    const [loading, setLoading] = useState(false)
    const answerPanelContainer = useRef(null)

    const generateSignature = () => {
        const {
            AccountId, UserId, MessageId, ServiceType
        } = conversation[0]
        // last message channel get
        let filteredConversation = conversation
        if (selectedChannel !== '*') {
            filteredConversation = filteredConversation.filter(
                item => item.Channel === selectedChannel
            )
        }
        const lastMessage = filteredConversation[filteredConversation.length - 1] || {}
        const currentChannel = lastMessage.Channel

        console.log('channel', currentChannel)
        console.log('1', conversation)
        console.log('2', filteredConversation)

        if (currentChannel === 'sms') {
            const signatureRaw = 'Opt-out reply STOP'
            const signature = `<br><br>${signatureRaw}`
            answerPanelContainer.current.innerText = signature
            answerPanelContainer.current.innerHTML = signature
            return
        }

        setLoading(true)
        axios({
            url: '/api/signature',
            method: 'GET',
            params: {
                accountId: AccountId,
                userId: UserId,
                messageId: MessageId,
                serviceType: ServiceType || 'LEAD_ENGAGE',
            },
        }).then(res => {
            const signatureRaw = res.data
            const signature = `<br><br>${signatureRaw}`
            answerPanelContainer.current.innerText = signature
            answerPanelContainer.current.innerHTML = signature
            // setSignature(signature)
            setLoading(false)
        })
    }
    useEffect(() => {
        generateSignature()
    }, [])

    const handleClick = () => {
        if (sendingProgress) {
            return
        }
        answerPanelContainer.current.innerText = answerPanelContainer.current.innerHTML
        const htmlText = answerPanelContainer.current.innerHTML.trim()
        const rawText = answerPanelContainer.current.innerText.trim()

        console.log({
            rawText,
            htmlText,
        })

        if (!htmlText || !rawText) {
            return
        }

        answerPanelContainer.current.innerHTML = ''

        onSend({ htmlText, rawText })
        generateSignature()
    }

    return (
        <div className='ConversationPanel__answer-panel'>
            <div
                ref={answerPanelContainer}
                spellCheck={false}
                dangerouslySetInnerHTML={{ __html: message }}
                className='editable-div scrollable'
                contentEditable
            ></div>
            <div onClick={handleClick} className='action-button'>
                {sendingProgress || loading ? (
                    <CircularProgress size={20} />
                ) : (
                    <p>Send</p>
                )}
            </div>
        </div>
    )
}

export default React.memo(AnswerPanel)
